import script from "./SidebarLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarLayout.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarLayout.vue?vue&type=style&index=0&id=529babb4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529babb4"]])

export default __exports__